module.exports = __webpack_public_path__ + "static/scale-model-of-tallahassee-museum-in-tallahassee-florida-dca4f81b655685cec3bae73a1037624c.png";